import React from 'react';
import { AssistantTyping } from '@features/sidebar/components/assistant-message/AssistantTyping';
import { convertMarkdownToHtml } from 'src/utils';

interface UserMessageProps {
  content: string;
  isLastUser?: boolean;
  showTyping?: boolean;
}

export const UserMessage = ({ content, isLastUser = false, showTyping = false }: UserMessageProps) => {
  return (
    <>
      <div className="flex justify-end items-center">
        <div className="user-message copilotKitMarkdownElementRight max-xl:py-2 max-xl:px-3 max-xl:mr-3 max-xl:my-3 max-xl:rounded-[8px]">
          {content && (
            <div
              className="copilotKitMarkdownElement"
              dangerouslySetInnerHTML={{ __html: convertMarkdownToHtml(content) }}
            />
          )}
        </div>
      </div>
      {showTyping && isLastUser && <AssistantTyping isLoading={true} />}
    </>
  );
};
